var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.43 68.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M47.93 37.68a6 6 0 0 0-3.18-1.85 5.21 5.21 0 0 0-5.1 2l-3.33 4a1.15 1.15 0 0 1-2.09-.76V12.21a9 9 0 0 0-.07-1.18 3.14 3.14 0 0 0-4.77-2.38 3.45 3.45 0 0 0-1.55 3.1V34.5a1.14 1.14 0 0 1-2.24.23 4 4 0 0 1-.06-.86V4.63a3.25 3.25 0 0 0-4.33-3A3.45 3.45 0 0 0 19 5v29a5 5 0 0 1 0 .75 1.14 1.14 0 0 1-2.26 0 6 6 0 0 1 0-.7V8.33a3.37 3.37 0 0 0-2.24-2.91 3 3 0 0 0-3.28 1 3.7 3.7 0 0 0-.77 2.42v25.08a3.6 3.6 0 0 1-.06.8 1.14 1.14 0 0 1-1.1.86 1.12 1.12 0 0 1-1.1-.86 3.7 3.7 0 0 1-.19-.67V19.83A8 8 0 0 0 8 19a3.26 3.26 0 0 0-3.59-3 3.33 3.33 0 0 0-2.88 3.43v34.75a21 21 0 0 0 .22 3.44 11 11 0 0 0 11 9.39h13.34A11.5 11.5 0 0 0 28 66.8a10.64 10.64 0 0 0 7.88-5.94Q41.08 50.9 46.23 41z",
    "data-name": "Layer 65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.bd8da849306704c6712e4e0c308157d9.svg";
export { ForwardRef as ReactComponent };